export const LIST_EMR_MEDICAL_DOCS_REQUEST =
  'LIST_EMR_MEDICAL_DOCS_REQUEST'
export const LIST_EMR_MEDICAL_DOCS_SUCCESS =
  'LIST_EMR_MEDICAL_DOCS_SUCCESS'
export const LIST_EMR_MEDICAL_DOCS_FAIL =
  'LIST_EMR_MEDICAL_DOCS_FAIL'

export const LIST_EMR_MEDICAL_DOCS_SUMMARY_REQUEST =
  'LIST_EMR_MEDICAL_DOCS_SUMMARY_REQUEST'
export const LIST_EMR_MEDICAL_DOCS_SUMMARY_SUCCESS =
  'LIST_EMR_MEDICAL_DOCS_SUMMARY_SUCCESS'
export const LIST_EMR_MEDICAL_DOCS_SUMMARY_FAIL =
  'LIST_EMR_MEDICAL_DOCS_SUMMARY_FAIL'

export const CREATE_EMR_MEDICAL_DOCS_REQUEST =
  'CREATE_EMR_MEDICAL_DOCS_REQUEST'
export const CREATE_EMR_MEDICAL_DOCS_SUCCESS =
  'CREATE_EMR_MEDICAL_DOCS_SUCCESS'
export const CREATE_EMR_MEDICAL_DOCS_FAIL =
  'CREATE_EMR_MEDICAL_DOCS_FAIL'

export const DETAIL_EMR_MEDICAL_DOCS_REQUEST =
  'DETAIL_EMR_MEDICAL_DOCS_REQUEST'
export const DETAIL_EMR_MEDICAL_DOCS_SUCCESS =
  'DETAIL_EMR_MEDICAL_DOCS_SUCCESS'
export const DETAIL_EMR_MEDICAL_DOCS_FAIL =
  'DETAIL_EMR_MEDICAL_DOCS_FAIL'

export const UPDATE_EMR_MEDICAL_DOCS_REQUEST =
  'UPDATE_EMR_MEDICAL_DOCS_REQUEST'
export const UPDATE_EMR_MEDICAL_DOCS_SUCCESS =
  'UPDATE_EMR_MEDICAL_DOCS_SUCCESS'
export const UPDATE_EMR_MEDICAL_DOCS_FAIL =
  'UPDATE_EMR_MEDICAL_DOCS_FAIL'

export const DELETE_EMR_MEDICAL_DOCS_REQUEST =
  'DELETE_EMR_MEDICAL_DOCS_REQUEST'
export const DELETE_EMR_MEDICAL_DOCS_SUCCESS =
  'DELETE_EMR_MEDICAL_DOCS_SUCCESS'
export const DELETE_EMR_MEDICAL_DOCS_FAIL =
  'DELETE_EMR_MEDICAL_DOCS_FAIL'

export const RESET_EMR_MEDICAL_DOCS = 'RESET_EMR_MEDICAL_DOCS'
